import React from 'react';
import { provisioningBoxesPath } from 'routing/paths';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import CommonButton from 'components/Buttons/CommonButton';

export const BoxDetailPageNotFound = (): JSX.Element => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      alignContent="space-between"
      justifyContent="center"
      height="80vh"
    >
      <Typography variant="h4">
        Box not found
      </Typography>

      <CommonButton type="button" label="Back to list" LinkTo={ provisioningBoxesPath } icon={ <ArrowBackIcon /> } />;
    </Box>
  );
};
